export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const validateFile = (file) => {
  if (!file) {
    return { isValid: false, error: 'No file selected' };
  }

  if (!file.name.toLowerCase().endsWith('.xlsx')) {
    return { isValid: false, error: 'Please select an Excel (.xlsx) file' };
  }

  if (file.size > 50 * 1024 * 1024) {
    return { isValid: false, error: 'File size must be less than 50MB' };
  }

  return { isValid: true };
};

export const formatFileSize = (bytes) => {
  return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
};

export const generateTemplateFilename = () => {
  const date = new Date().toISOString().split('T')[0];
  return `BiPortal_User_Import_Template_${date}.xlsx`;
};